export default __webpack_public_path__ + "static/media/image-2.20bf8aea.jpeg";